import { ReactNode } from "react";

import useTitle from "hooks/useTitle";
import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";
import PageInfoHeader from "ds/components/PageInfoHeader";

type TemplateDeploymentsPageLayoutProps = {
  children?: ReactNode;
  titleId: string;
};

const TemplateDeploymentsPageLayout = ({ children }: TemplateDeploymentsPageLayoutProps) => {
  const { accountName } = useTypedContext(AccountContext);

  useTitle(`Template Deployments · ${accountName}`);

  return (
    <>
      <PageInfoHeader title="Deployments" />

      {children}
    </>
  );
};

export default TemplateDeploymentsPageLayout;
